// World clock - live times across selectable time zones.
import { el, btn, sel, wrap } from "./ui.js";
import { readJSON, writeJSON } from "../shared/store.js";

const KEY = "revault:worldclock";
const ZONES = [
	["UTC", "UTC"], ["America/Los_Angeles", "Los Angeles"], ["America/Denver", "Denver"], ["America/Chicago", "Chicago"],
	["America/New_York", "New York"], ["America/Sao_Paulo", "São Paulo"], ["Europe/London", "London"], ["Europe/Paris", "Paris"],
	["Europe/Berlin", "Berlin"], ["Europe/Moscow", "Moscow"], ["Africa/Cairo", "Cairo"], ["Asia/Dubai", "Dubai"],
	["Asia/Kolkata", "Mumbai"], ["Asia/Shanghai", "Shanghai"], ["Asia/Tokyo", "Tokyo"], ["Asia/Singapore", "Singapore"],
	["Australia/Sydney", "Sydney"], ["Pacific/Auckland", "Auckland"], ["America/Honolulu", "Honolulu"],
];
const labelOf = (tz) => (ZONES.find((z) => z[0] === tz) || [tz, tz])[1];

export function worldclock(root) {
	const s = wrap(root); s.classList.add("rv-wclock");
	let zones = readJSON(KEY, ["UTC", "America/New_York", "Europe/London", "Asia/Tokyo"]);
	if (!Array.isArray(zones) || !zones.length) zones = ["UTC"];

	const addSel = sel(ZONES.map(([v, l]) => [v, l]), "UTC");
	addSel.setAttribute("aria-label", "Time zone to add");
	const addBtn = btn("+ Add", () => { if (!zones.includes(addSel.value)) { zones.push(addSel.value); writeJSON(KEY, zones); renderList(); } }, "rv-tbtn rv-tbtn-accent");
	const controls = el("div", "rv-trow"); controls.append(addSel, addBtn);
	const listEl = el("div", "rv-wclock-list");
	s.append(controls, listEl);

	function renderList() {
		listEl.textContent = "";
		zones.forEach((tz) => {
			const card = el("div", "rv-wclock-card");
			card.append(el("div", "rv-wclock-city", labelOf(tz)));
			const time = el("div", "rv-wclock-time", "--:--:--"); time.dataset.tz = tz;
			const date = el("div", "rv-wclock-date", ""); date.dataset.tz = tz; date.dataset.role = "date";
			card.append(time, date);
			const rm = btn("✕", () => { zones = zones.filter((z) => z !== tz); writeJSON(KEY, zones); renderList(); }, "rv-wclock-del");
			rm.setAttribute("aria-label", "Remove " + labelOf(tz));
			card.append(rm);
			listEl.appendChild(card);
		});
		update();
	}
	function update() {
		const now = new Date();
		listEl.querySelectorAll(".rv-wclock-time").forEach((t) => {
			try { t.textContent = now.toLocaleTimeString("en-US", { timeZone: t.dataset.tz, hour12: true }); } catch (e) { t.textContent = "-"; }
		});
		listEl.querySelectorAll('[data-role="date"]').forEach((d) => {
			try { d.textContent = now.toLocaleDateString(undefined, { timeZone: d.dataset.tz, weekday: "short", month: "short", day: "numeric" }); } catch (e) {}
		});
	}
	renderList();
	const iv = setInterval(update, 1000);
	// tool tabs reload fresh; interval lives for the tab's lifetime
	window.addEventListener("pagehide", () => clearInterval(iv), { once: true });
}
